import React, { } from "react";
import {
    Modal, Grid, Button
} from 'semantic-ui-react';
import { Constants } from "../../../config/appConstants";
const AttachmentViewerComponent = props => {
    return (
        <Modal
            open={props.attachmentViewer.isModalVisible}
            onOpen={props.openModal}
            onClose={() => props.closeModal()}
            size='large'
            closeOnEscape={false}
            closeOnDimmerClick={false}
        >
            <Modal.Header className="text-center">Attachment</Modal.Header>
            <Modal.Content scrolling>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={16} textAlign="center">
                            <img alt={props.attachmentViewer.attachmentName} src={Constants.DATA_BASE64 +props.attachmentViewer.attachmentContent} />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Modal.Content>
            <Modal.Actions>
                <Button secondary className="borderRadius w-25 ml-0" size='small' onClick={() => props.closeModal()}>Back</Button>
            </Modal.Actions>
        </Modal>
    );
}

export default AttachmentViewerComponent;

AttachmentViewerComponent.displayName = "AttachmentViewerComponent";